"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallmentItem = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const installmentRowsStyles_1 = __importDefault(require("./installmentRowsStyles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const constants_1 = require("../../constants/constants");
const utils_1 = require("../../utils/utils");
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../text/text"));
const InstallmentItem = ({ id, amount, penalty, amountRemaining, status, dateDue }) => {
    let amountPenaltyView = null;
    let amountLeftView = null;
    if (penalty > 0) {
        amountPenaltyView = (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, style: installmentRowsStyles_1.default.textLeft }, constants_1.NAIRA_SYMBOL + (0, utils_1.formatNumber)(amount + penalty)));
    }
    if (amountRemaining > 0 && amountRemaining < amount) {
        amountLeftView = (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, style: installmentRowsStyles_1.default.textLeft }, constants_1.NAIRA_SYMBOL + (0, utils_1.formatNumber)(amountRemaining)));
    }
    let textColor;
    /* eslint indent: [2, 4, {"SwitchCase": 1}] */
    switch (status) {
        case 'PAID':
            textColor = theme_1.default.colors.COLOR_PRIMARY;
            break;
        case 'OVERDUE':
            textColor = theme_1.default.colors.COLOR_CRITICAL;
            break;
        case 'PAID PARTIALLY':
            textColor = theme_1.default.colors.COLOR_GRAY;
            break;
        default:
            textColor = theme_1.default.colors.COLOR_GRAY;
    }
    return (react_1.default.createElement(react_native_1.View, { key: id, style: [
            installmentRowsStyles_1.default.container,
            {
                backgroundColor: status === 'OVERDUE' ? theme_1.default.colors.COLOR_RED_VERY_LIGHT : theme_1.default.colors.COLOR_OFF_WHITE,
            },
        ] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12 }, dateDue)),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, color: textColor }, status))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY }, `Installment #${id}`),
                penalty > 0 || status === 'OVERDUE' ? (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, color: theme_1.default.colors.COLOR_CRITICAL }, `+${constants_1.NAIRA_SYMBOL} ${(0, utils_1.formatNumber)(penalty)} late fee`)) : null,
                amount - amountRemaining > 0 ? (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, style: installmentRowsStyles_1.default.greenTextLeft }, `-${constants_1.NAIRA_SYMBOL} ${(0, utils_1.formatNumber)(amount - amountRemaining)} paid`)) : null),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: {
                        backgroundColor: status === 'OVERDUE' ? theme_1.default.colors.COLOR_RED_VERY_LIGHT : theme_1.default.colors.COLOR_OFF_WHITE,
                    } }, constants_1.NAIRA_SYMBOL + (0, utils_1.formatNumber)(amount)),
                amountPenaltyView,
                amountLeftView))));
};
exports.InstallmentItem = InstallmentItem;
const InstallmentRows = ({ installments }) => {
    return (react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false }, installments.map((installment) => (react_1.default.createElement(exports.InstallmentItem, { key: installment.id, id: installment.id, amount: installment.amount, penalty: installment.penalty, amountRemaining: installment.amount_remaining, status: installment.status, dateDue: installment.date_due })))));
};
exports.default = InstallmentRows;
